import * as i0 from '@angular/core';
import { Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

class E11ErrorMessagesComponent {
    constructor() {
        this.errorMessages = [];
        this.destroy$ = new Subject();
        // Intentionally using two values here.
        // We need to NOT use the returnedMessage to control the show/hide animation.
        this.returnedMessage = '';
        this.showError = false;
    }
    ngOnInit() {
        this.controls?.statusChanges?.pipe(takeUntil(this.destroy$))?.subscribe(() => {
            this.validate();
        });
    }
    processErrorMessages(error) {
        const messqge = this.errorMessages.find((obj) => {
            return obj.error === error;
        });
        this.returnedMessage = messqge?.message;
    }
    validate() {
        if ((this.controls.touched || this.controls.dirty) && this.controls.errors && Object.keys(this.controls.errors).length > 0) {
            let key = Object.keys(this.controls.errors)[0];
            this.processErrorMessages(key);
            this.showError = true;
        }
        else {
            // This saves the last error message in place and lets it slide away then removes value after the animation
            setTimeout(() => {
                this.returnedMessage = '';
            }, 250);
            this.showError = false;
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ErrorMessagesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11ErrorMessagesComponent, selector: "e11-error-messages", inputs: { controls: "controls", errorMessages: "errorMessages" }, ngImport: i0, template: "<div class=\"e11-error-messages e11-absolute e11-h-7\">\n  <span class=\"e11-error-message e11-absolute e11-text-skin-error e11-text-sm\" [ngClass]=\"{ 'e11-error-message-active': showError }\">\n    {{ returnedMessage }}\n  </span>\n</div>\n", styles: [".e11-error-messages{display:inline-block;width:100%;opacity:1;z-index:0;overflow:hidden}.e11-error-messages .e11-error-message{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:inherit;top:-12px;opacity:0;z-index:-1;transition:top .25s ease-in-out 0s,opacity .25s ease-in-out 0s,z-index 0s linear 0s}.e11-error-messages .e11-error-message.e11-error-message-active{top:4px;opacity:1;z-index:1;transition:top .25s ease-in-out 0s,opacity .25s ease-in-out 0s,z-index 0s linear 0s}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ErrorMessagesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-error-messages', template: "<div class=\"e11-error-messages e11-absolute e11-h-7\">\n  <span class=\"e11-error-message e11-absolute e11-text-skin-error e11-text-sm\" [ngClass]=\"{ 'e11-error-message-active': showError }\">\n    {{ returnedMessage }}\n  </span>\n</div>\n", styles: [".e11-error-messages{display:inline-block;width:100%;opacity:1;z-index:0;overflow:hidden}.e11-error-messages .e11-error-message{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:inherit;top:-12px;opacity:0;z-index:-1;transition:top .25s ease-in-out 0s,opacity .25s ease-in-out 0s,z-index 0s linear 0s}.e11-error-messages .e11-error-message.e11-error-message-active{top:4px;opacity:1;z-index:1;transition:top .25s ease-in-out 0s,opacity .25s ease-in-out 0s,z-index 0s linear 0s}\n"] }]
        }], ctorParameters: () => [], propDecorators: { controls: [{
                type: Input
            }], errorMessages: [{
                type: Input
            }] } });

class E11ErrorMessagesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ErrorMessagesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11ErrorMessagesModule, declarations: [E11ErrorMessagesComponent], imports: [CommonModule], exports: [E11ErrorMessagesComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ErrorMessagesModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11ErrorMessagesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [E11ErrorMessagesComponent],
                    imports: [CommonModule],
                    exports: [E11ErrorMessagesComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { E11ErrorMessagesComponent, E11ErrorMessagesModule };
